import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_staff/settings/persons/")({
  beforeLoad() {
    throw redirect({ to: "/settings/persons/staff" });
  },
});
